import { t } from "i18next";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import MicrophoneIcon from "@/assets/icons/mic.svg?react";

interface Props {
  onClick: () => void;
}

export const MicrophoneButton = (props: Props): JSX.Element => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            className="inline-flex cursor-pointer"
            onClick={props.onClick}
          >
            <MicrophoneIcon
              aria-label="Mic"
              height={100}
              strokeWidth={0.5}
              width={100}
            />
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{t("components.microphoneButton.tooltip")}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
